export default "/_next/static/media/jordan-delta-2-shoe-dG2Stx.0576f08b06550a19220b8c3c5b19138c.jpeg";